import React, { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { Image } from 'semantic-ui-react';
import defaultUserAvatar from '../img/avatars/default-avatar.png';
import { SatCoreRegister } from '../SatCoreRegistry';

const Avatar = ({ ariaHidden = false, className, defaultImage, fullProfileImageUrl }) => {
  const { userManager } = useContext(MobXProviderContext);
  const defaultAvatar = defaultImage || defaultUserAvatar;
  const alt = userManager.displayName ? `User avatar for ${userManager.displayName}` : 'User avatar';

  return (
    <Image
      alt={alt}
      aria-hidden={ariaHidden || undefined}
      avatar
      className={className}
      onError={(i) => i.target.src = defaultAvatar}
      src={(fullProfileImageUrl === null) ? defaultAvatar : fullProfileImageUrl} />
  );
};

export default Avatar;

SatCoreRegister('Avatar', Avatar);
